import * as actions from './CourtsList.actions';
import * as types from './CourtsList.types';
import * as selectors from './CourtsList.selectors';
import reducer from './CourtsList.reducer';

export default {
  actions,
  reducer,
  types,
  selectors,
};
